const minin = {
  data() {
    return {
      allBtnWidth: 100,
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data)
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '添加',
      viewMode: false,
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const { created_at, ...obj } = v
          let time = created_at
          if (typeof created_at === 'string' && created_at.includes(' ')) {
            const arr = created_at.split(' ')
            time = arr[0];
          }
          obj['created_at'] = time
          obj.open = v.is_display + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id, is_display, name }) {
      // console.log(id)
      let display = (is_display === 1 ? 2 : 1)
      let url = `${this.baseUrl}/${this.modalSubmitUrl}`;
      const params = {
        userid: this.user.id,
        id,
        is_display: display
      }
      if (name) params['name'] = name
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          // 禁止隐藏，并刷新
          this.getList()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    add() {
      delete this.mform.id
      this.mform = {
        name: undefined,
        is_display: 1,
      }
      this.title = '添加'
      this.showDialog()
    },
    getItem({ id, name, is_display, sort }) {
      this.mform = { ...this.mform, id, name, is_display, sort }
      this.title = '修改'
    },
  },
  mounted() { },
}

export default minin